module.exports = __webpack_public_path__ + "img/img_3_.1da6c635.png";